<div class="d-flex justify-content-center align-items-center">
  <button class="no-styles button" [ngClass]="{'button-inverted': type === 'inverted'}" [class.disabled]="disabled"
    [disabled]="disabled">
    <div [ngClass]="popup ? 'd-block' : 'd-flex align-items-center'">
      <ng-content></ng-content>
    </div>
  </button>
</div>
